import UseAxios from '../../Api/http/http';
import { categoryList } from '../../Api/request/certificationCategoryMaster';

export const fetchCategoryList = async () => {
  try {
    const response = await UseAxios(categoryList());
    const result = response?.data?.certificationCategoryDetails || [];

    return result;
  } catch (error) {
    return [];
  }
};

export const getUniqueCategories = async (filterData) => {
  const uniqueCategories = await filterData.reduce((acc, item) => {
    if (!acc.some((categoryItem) => categoryItem.name === item.categoryName)) {
      acc.push({ id: item.id, name: item.categoryName });
    }
    return acc;
  }, []);

  return uniqueCategories;
};

export const getUniqueSubCategories = async (filterData) => {
  const uniqueSubCategories = await filterData.reduce((acc, item) => {
    if (
      !acc.some(
        (subcategoryItem) => subcategoryItem.name === item.subCategoryName,
      )
    ) {
      acc.push({ id: item.subCategoryId, name: item.subCategoryName });
    }
    return acc;
  }, []);

  return uniqueSubCategories;
};
